import { type TrackingType } from '../../../types';
export const EVENT_TYPES: { value: TrackingType; label: string }[] = [
	{
		value: "injection",
		label: "Injection",
	},
	{
		value: "shockwave",
		label: "Shockwave",
	},
	// {
	// 	value: "medication",
	// 	label: "Medication",
	// },
	{ value: "surgery", label: "Surgery" },
	{ value: "education", label: "Education" },
	// { value: "product", label: "Product" },
	
];